module.exports = __webpack_public_path__ + "img/siege-of-shanghai.321c105d.jpg";